import React from 'react';
import ProductCard from './ProductCard';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { sortOptions } from '../data/mockData';

const ProductGrid = ({ products, sortBy, onSortChange }) => {
  const currentPage = 1;
  const totalPages = 13;
  const productsPerPage = 48;

  const pages = [1, 2, 3];

  return (
    <div className="flex-1">
      {/* Sort & Title Row */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
        <div className="md:order-2">
          <div className="relative inline-block">
            <select
              value={sortBy}
              onChange={(e) => onSortChange(e.target.value)}
              className="appearance-none bg-transparent border-b border-gray-300 py-2 pr-8 text-sm text-gray-600 focus:outline-none focus:border-[#1a365d] cursor-pointer"
            >
              {sortOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <ChevronDown className="w-4 h-4 absolute right-0 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
          </div>
        </div>
      </div>

      {/* Title */}
      <h2 className="text-2xl md:text-3xl font-light text-[#1a365d] mb-6 tracking-wide">
        Responsibly & Ethically Sourced Engagement Rings
      </h2>

      {/* Pagination Top */}
      <div className="flex items-center justify-end gap-2 mb-6">
        {pages.map((page) => (
          <button
            key={page}
            className={`w-8 h-8 flex items-center justify-center text-sm transition-colors ${
              page === currentPage
                ? 'bg-[#1a365d] text-white'
                : 'border border-gray-300 text-gray-600 hover:border-[#1a365d] hover:text-[#1a365d]'
            }`}
          >
            {page}
          </button>
        ))}
        <span className="text-gray-400">...</span>
        <button className="w-8 h-8 flex items-center justify-center text-sm border border-gray-300 text-gray-600 hover:border-[#1a365d] hover:text-[#1a365d] transition-colors">
          {totalPages}
        </button>
        <button className="flex items-center gap-1 text-sm text-gray-600 hover:text-[#1a365d] transition-colors ml-2">
          Next
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>

      {/* Product Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>

      {/* Pagination Bottom */}
      <div className="flex items-center justify-center gap-2 mt-10 pt-8 border-t border-gray-200">
        {pages.map((page) => (
          <button
            key={page}
            className={`w-8 h-8 flex items-center justify-center text-sm transition-colors ${
              page === currentPage
                ? 'bg-[#1a365d] text-white'
                : 'border border-gray-300 text-gray-600 hover:border-[#1a365d] hover:text-[#1a365d]'
            }`}
          >
            {page}
          </button>
        ))}
        <span className="text-gray-400">...</span>
        <button className="w-8 h-8 flex items-center justify-center text-sm border border-gray-300 text-gray-600 hover:border-[#1a365d] hover:text-[#1a365d] transition-colors">
          {totalPages}
        </button>
        <button className="flex items-center gap-1 text-sm text-gray-600 hover:text-[#1a365d] transition-colors ml-2">
          Next
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default ProductGrid;
